import { Box, Divider, Grid, Paper, Typography, Chip, Modal } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useStyles } from '../styles';
import Images from '../../../Assets/assetHelper';
import KenColors from '../../../Helpers/Themes/kenColors';
import { AppButton } from '../../../Components/AppButton';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { useSnackbar } from 'notistack';
import KenDialog from '../../../GlobalComponents/KenDialog';
import ChatBox from '../../../GlobalComponents/ChatBox';
import { getGroupEnrollmentDetail, GetlastMessage, groupEnrollment, LeftGroups, postApprovalStatus } from '../../../Utils/apiService';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { format } from 'date-fns';
import { enGB, id } from 'date-fns/locale';
import KenLoader from '../../../GlobalComponents/KenLoader';
import { TextField, IconButton, Avatar, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from '@mui/icons-material/Search';
import StatusChip from '../../../Components/AppChip';

const CreatedGroupsDetails = () => {
  const classes: any = useStyles();
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const searchParams = new URLSearchParams(location.search);
  const groupId: any = searchParams.get('id');
  const [chatid, setchatid] = useState('');
  const [memberlist, setMemberlist] = useState<any>([]);
  console.log(memberlist, 'memberlist');

  const pathSegments = location.pathname.split('/');
  const groupName = decodeURIComponent(pathSegments[pathSegments.length - 1]);
  const [loading, setLoading] = useState(false);
  const [groupEnrollmentData, setGroupEnrollmentData] = useState<any>(null);
  const data = {
    name: groupName,
    id: groupId,
    chatid: chatid,
    coverImage: groupEnrollmentData?.Cover_Image_Url__c,
  };
  const { enqueueSnackbar } = useSnackbar();
  const [joinedGroup, setjoinedGroup] = useState<boolean>(false);
  const [cancelRegistration, setCancelRegistration] = useState<boolean>(false);
  const [isChatBoxOpen, setChatBoxOpen] = useState(false);
  const [LeftGroupId, setLeftGroupId] = useState<string>('');
  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A'; // Handle cases where date is null
    const date = new Date(dateString);
    return format(date, 'dd MMM yyyy', { locale: enGB }); // Formats like "12 Jun 2022"
  };
  const [open, setOpen] = useState(false);

  const [requestedSearchTerm, setRequestedSearchTerm] = useState('');
  const [membersSearchTerm, setMembersSearchTerm] = useState('');

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const [openMember, setOpenMember] = useState(false);
  const handleCloseviewMenber = () => setOpenMember(false);
  const handleOpenviewMenber = () => setOpenMember(true);
  const [Pendinglist, setPendinglist] = useState<any>([]);

  // Fix: Use requestedSearchTerm for requested list filtering
  const filteredRequestedData = Pendinglist?.filter(
    (item: any) => item.Alumni_Member__r && item.Alumni_Member__r.Name && item.Alumni_Member__r.Name.toLowerCase().includes(requestedSearchTerm.toLowerCase())
  ).map((item: any) => ({
    name: item.Alumni_Member__r?.Name || 'Unknown',
    img: item.Alumni_Member__r?.Profile_Picture_URL__c || '',
    batch: item.Alumni_Member__r?.Batch__c || '', // Add batch if available
    id: item.Id, // <-- add id here
  }));

  const filteredMembersData = memberlist
    ?.filter((item: any) => item.Alumni_Member__r && item.Alumni_Member__r.Name && item.Alumni_Member__r.Name.toLowerCase().includes(membersSearchTerm.toLowerCase()))
    .map((item: any) => ({
      name: item.Alumni_Member__r?.Name || 'Unknown',
      img: item.Alumni_Member__r?.Profile_Picture_URL__c || '', // fallback to empty string if not present
    }));
  console.log(Pendinglist, 'Pendinglist');

  useEffect(() => {
    setLoading(true);

    if (groupId) {
      getGroupEnrollmentDetail(userData?.applicantId, groupId).then((res) => {
        setGroupEnrollmentData(res?.data?.data?.groupDetails);
        setPendinglist(
          res?.data?.data?.groupDetails?.Group_Members__r?.records?.filter((item: any) => item.enrollmentRequestAccepted__c === false && item?.EnrollmentRequestRejected__c === false) || []
        );
        setLeftGroupId(res?.data?.data?.enrollmentDetails?.Id);
        setMemberlist(
          res?.data?.data?.groupDetails?.Group_Members__r?.records?.filter((item: any) => item.enrollmentRequestAccepted__c === true && item?.EnrollmentRequestRejected__c === false) || []
        );
        if (res?.data?.data?.enrollmentDetails === null) {
          setjoinedGroup(false);
          setLoading(false);
        } else {
          if (res?.data?.data?.enrollmentDetails?.isActive__c == true) {
            setjoinedGroup(true);
            setchatid(res?.data?.data?.groupDetails?.ChatRoomId__c);
            setLoading(false);
          } else {
            setjoinedGroup(false);
            setLoading(false);
          }
        }
      });
    }
  }, []);
  const handleOpenMessage = () => {
    setChatBoxOpen(true);
  };

  const handleChatBoxClose = () => {
    setChatBoxOpen(false);
  };

  const handleOpenLeaveGroup: () => void = () => {
    setCancelRegistration(!cancelRegistration);
  };

  const reload = () => {
    if (groupId) {
      getGroupEnrollmentDetail(userData?.applicantId, groupId).then((res) => {
        setGroupEnrollmentData(res?.data?.data?.groupDetails);
        setPendinglist(
          res?.data?.data?.groupDetails?.Group_Members__r?.records?.filter((item: any) => item.enrollmentRequestAccepted__c === false && item?.EnrollmentRequestRejected__c === false) || []
        );
        setLeftGroupId(res?.data?.data?.enrollmentDetails?.Id);
        setMemberlist(
          res?.data?.data?.groupDetails?.Group_Members__r?.records?.filter((item: any) => item.enrollmentRequestAccepted__c === true && item?.EnrollmentRequestRejected__c === false) || []
        );
        if (res?.data?.data?.enrollmentDetails === null) {
          setjoinedGroup(false);
          setLoading(false);
        } else {
          if (res?.data?.data?.enrollmentDetails?.isActive__c == true) {
            setjoinedGroup(true);
            setchatid(res?.data?.data?.groupDetails?.ChatRoomId__c);
            setLoading(false);
          } else {
            setjoinedGroup(false);
            setLoading(false);
          }
        }
      });
    }
  };
  const aproveRequest = (id: string) => {
    console.log(user, 'useruseruseruseruser');
    setLoading(true);
    const payload: any = {
      enrollmentRequestAccepted__c: 'true',
    };
    postApprovalStatus(id, payload).then((res) => {
      reload();
    });
  };
  const rejectRequest = (id: string) => {
    const payload: any = {
      EnrollmentRequestRejected__c: 'true',
    };
    postApprovalStatus(id, payload).then((res) => {
      reload();
    });
  };

  const handleLeaveGroup = () => {
    LeftGroups(LeftGroupId).then((res) => {
      if (res?.success == true) {
        const message = (
          <Box>
            <Typography sx={{ fontSize: '16px', fontWeight: '600', lineHeight: '22px' }}>Left the group successfully !</Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '22px' }}>You have left the {groupName}</Typography>
          </Box>
        );
        enqueueSnackbar(message, { variant: 'success', autoHideDuration: 1000 });
        setCancelRegistration(!cancelRegistration);
        navigate(`/groups/${groupName}?id=${groupId}`);
      } else {
        enqueueSnackbar('Unable to process your request at the moment. Please check your connection and try again.', {
          variant: 'error',
          autoHideDuration: 1000,
        });
        setCancelRegistration(!cancelRegistration);
        setjoinedGroup(true);
      }
    });

    setjoinedGroup(false);
  };
  useEffect(() => {
    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      navigate('/groups/your-groups', { replace: true });
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);
  useEffect(() => {
    if (navigationType === 'PUSH') {
      sessionStorage.removeItem('groupsDetailsExit');
      return;
    }
    if (navigationType === 'POP' && sessionStorage.getItem('groupsDetailsExit') === '1') {
      sessionStorage.removeItem('groupsDetailsExit');
      navigate('/groups/your-groups', { replace: true });
    }
  }, [navigationType, navigate]);

  useEffect(() => {
    return () => {
      sessionStorage.setItem('groupsDetailsExit', '1');
    };
  }, []);
  const [lastMessage, setLastMessage] = useState<any>(null);
  console.log(lastMessage, 'lastMessage12343234');

  useEffect(() => {
    if (chatid) {
      GetlastMessage(chatid).then((res: any) => {
        const message = res?.data?.data[0]?.lastMessage?.timestamp;
        console.log(message,"skfjnfjk");
        
        setLastMessage(message);
      });
    }
  }, [chatid]);
const formatTimeAgo = (timestamp?: number) => {
  console.log(timestamp,"sfjknefj");
  
  if (!timestamp || isNaN(timestamp)) {
  return "";// or "--" / "N/A"
  }

  const now = Date.now();
  const diff = Math.floor((now - timestamp) / 1000);

  if (diff < 0) return "Just now";
  if (diff < 60) return `${diff} sec ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
  return `${Math.floor(diff / 86400)} days ago`;
};
  return (
    <>
      {loading && <KenLoader />}
      <KenDialog
        maxWidth={'500px'}
        open={cancelRegistration}
        handleClose={handleOpenLeaveGroup}
        hidePositiveButton={true}
        dialogActions={true}
        positiveButtonClick={handleLeaveGroup}
        hideNegativeButton={false}
        negativeButtonText={"No, don't leave"}
        negativeButtonClick={handleOpenLeaveGroup}
        hideCustomPositiveButton={false}
        customPositiveButtonText="Yes"
        customPositiveButtonStyle={classes.customPositiveButtonStyle}
        dialogActionProps={{
          sx: {
            '& .MuiButton-root': {
              minWidth: { xs: '120px', sm: '160px' },
            },
          },
        }}
      >
        <Typography fontSize={'15px'} width={'500px'} whiteSpace={'wrap'}>
          Are you sure your want to leave the group?
        </Typography>
      </KenDialog>
      <Grid item container>
        <Paper
          className={`${classes.paperCustom} scrollbar-cusgrayHeader`}
          sx={{
            height: { xs: 'auto', sm: '83.5vh' },
            overflow: { xs: 'visible', sm: 'auto' },
          }}
        >
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Box className={classes.groupTagContainer}>
                {groupEnrollmentData?.Tags__c ? (
                  <Chip
                    label={groupEnrollmentData?.Tags__c ? groupEnrollmentData?.Tags__c : null}
                    size="small"
                    sx={{
                      backgroundColor: '#BFCEFF',
                      color: '#1A358C',
                      padding: '3px 9px 3px 9px',
                      height: '27px',
                      '& .MuiChip-label': {
                        fontSize: '12px',
                        fontWeight: '500',
                        padding: '3px 9px 3px 9px',
                      },
                    }}
                  />
                ) : null}
              </Box>
            </Grid>
            <Grid item lg={4} xs={12}>
              <img src={groupEnrollmentData?.Cover_Image_Url__c ? groupEnrollmentData?.Cover_Image_Url__c : Images.Images.NoDataTheme} alt={'Entrepeneurs of Ken42'} className={classes.eventBanner} />
            </Grid>
            <Grid item lg={4.5} xs={12}>
              <Box className={classes.boxContainer1}>
                <Typography className={classes.aboutTheGroupContainerHeaderTypo}>About the Group</Typography>
                <Typography className={classes.subTypo} marginTop={'12px'}>
                  {groupEnrollmentData?.Description__c}
                </Typography>
              </Box>
            </Grid>
            <Grid item lg={3} xs={12}>
              <Box className={classes.boxContainer1}>
                
                <Typography className={classes.aboutTheGroupContainerHeaderTypo} marginBottom={'12px'} >
                  Rules of the Group
                </Typography>
                {groupEnrollmentData?.Group_Rules__c?.split(';')
                  .filter((rule: string) => rule.trim() !== '')
                  .map((rule: string, index: number) => (
                    <Box className={classes.boxContainer2} sx={{ marginBottom: { xs: '8px', md: '10px' } }}>
                    <Box key={index} className={classes.boxContainer2} sx={{ marginBottom: { xs: '8px', md: '10px' } }}>
                      <img src={Images.Icons.Check} alt="" />
                        <Typography className={classes.subTypo} component="div" dangerouslySetInnerHTML={{ __html: rule || '' }} />
                      </Box>
                    </Box>
                  ))}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Divider color={KenColors.ClientBlue4} />
              <Box className={classes.boxContainer3}>
                <Box>
                  <Box className={classes.boxContainer4}>
                    <Typography className={classes.activeTypo}>Last active: {formatTimeAgo(lastMessage)}</Typography>
                    <Box className={classes.activityContainer} style={{ cursor: 'pointer' }} onClick={handleOpenviewMenber}>
                      <PeopleAltOutlinedIcon />
                      <Typography className={classes.activeTypo}> {memberlist?.length}</Typography>
                    </Box>
                  </Box>
                  <Typography className={classes.activeTypo} sx={{ color: KenColors.ClientGrey, marginTop: '8px' }}>
                    Started on: {formatDate(groupEnrollmentData?.CreatedDate)}
                  </Typography>
                </Box>

                {joinedGroup ? (
                  <Box className={classes.joinedGroupContainer}>
                    <Typography sx={{ color: '#5981FF', fontSize: '12px', fontWeight: 500, mt: 1, mr: 2, cursor: 'pointer' }} onClick={handleOpen}>
                      Join list
                    </Typography>
                    <AppButton size="large" className={classes.appButtonMessage} onClick={handleOpenMessage}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Message</Typography>
                    </AppButton>
                    <AppButton
                      size="large"
                      className={classes.appButtonLeave}
                      onClick={() => {
                        handleOpenLeaveGroup();
                      }}
                    >
                      <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Leave Group</Typography>
                    </AppButton>
                  </Box>
                ) : (
                  <StatusChip color="default" label={'Pending for Approval'}></StatusChip>
                )}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {isChatBoxOpen && <ChatBox onClose={handleChatBoxClose} mentordetails={data} name={groupName} avatarImg={Images.Images.NoDataTheme} />}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            width: '35%',
            bgcolor: 'white',
            p: 2,
            borderRadius: 2,
            mx: 'auto',
            my: '10%',
            boxShadow: 24,
            maxHeight: '80vh',
            overflow: 'hidden',
            '@media (max-width:626px)': {
              width: '90%',
              height: '90%',
            },
          }}
        >
          {/* Title */}
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography fontSize={14} fontWeight={500}>
              Join List
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />
          {/* Search */}
          <TextField
            placeholder="Search"
            size="small"
            variant="outlined"
            sx={{ my: 2, width: { xs: '100%', sm: '260px' } }}
            value={requestedSearchTerm}
            onChange={(e) => setRequestedSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          {/* User List */}
          <Box
            sx={{
              overflowY: 'auto',
              maxHeight: 'calc(60vh - 130px)',
              pr: 1,
              '&::-webkit-scrollbar': {
                width: 0,
              },
              '-ms-overflow-style': 'none',
              scrollbarWidth: 'none',
            }}
          >
            {filteredRequestedData.map((user: { img: string | undefined; name: any; batch: any; id: string }, index: React.Key | null | undefined) => (
              <Box key={index} display="flex" alignItems="center" justifyContent="space-between" p={1} borderRadius={2} mb={1} sx={{ bgcolor: '#f9f9f9' }}>
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Avatar src={user.img} />
                  <Box>
                    <Typography fontSize={14} fontWeight={500}>
                      {user.name}
                    </Typography>
                    <Typography fontSize={12} color="text.secondary">
                      Batch - {user.batch}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" gap={1}>
                  <IconButton size="small" sx={{ bgcolor: '#EEF1FF' }}>
                    <CloseIcon
                      sx={{ fontSize: 18 }}
                      onClick={() => {
                        rejectRequest(user?.id);
                      }}
                    />
                  </IconButton>
                  <IconButton size="small" sx={{ bgcolor: '#5981FF', color: '#fff' }}>
                    <DoneIcon
                      sx={{ fontSize: 18 }}
                      onClick={() => {
                        aproveRequest(user?.id);
                      }}
                    />
                  </IconButton>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>

      <Modal open={openMember} onClose={handleCloseviewMenber}>
        <Box
          sx={{
            width: 400,
            bgcolor: 'white',
            p: 2,
            borderRadius: 2,
            mx: 'auto',
            my: '10%',
            boxShadow: 24,
            maxHeight: '80vh',
            overflow: 'hidden',
            '@media (max-width:626px)': {
              width: '90%',
              height: '90%',
            },
          }}
        >
          {/* Header */}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography fontSize={14} fontWeight={500}>
              Members
            </Typography>
            <IconButton onClick={handleCloseviewMenber} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ my: 1 }} />

          {/* Search Bar */}
          <TextField
            placeholder="Search"
            size="small"
            variant="outlined"
            value={membersSearchTerm}
            onChange={(e) => setMembersSearchTerm(e.target.value)}
            sx={{ mb: 2, width: { xs: '100%', sm: '260px' } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          {/* Scrollable User List */}
          <Box
            sx={{
              overflowY: 'auto',
              maxHeight: 'calc(80vh - 130px)',
              pr: 1,
              '&::-webkit-scrollbar': {
                width: 0,
              },
              '-ms-overflow-style': 'none',
              scrollbarWidth: 'none',
            }}
          >
            {filteredMembersData?.map(
              (
                user: {
                  img: string | undefined;
                  name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined;
                },
                index: React.Key | null | undefined
              ) => (
                <Box key={index} display="flex" alignItems="center" justifyContent="space-between" p={1.2} borderRadius={2} mb={1} sx={{ bgcolor: '#F6F8FB' }}>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Avatar src={user.img} />
                    <Typography fontSize={14} fontWeight={500}>
                      {user.name}
                    </Typography>
                  </Box>
                  {/* Remove batch display */}
                </Box>
              )
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};
export default CreatedGroupsDetails;
